var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 2,
    rx: 1,
    fill: "#7C8194"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 19,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 19,
    height: 2,
    rx: 1,
    fill: "#7C8194"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#7C8194"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#7C8194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerIcon);
export default __webpack_public_path__ + "static/media/drawerIcon.18a7cde75b83970a57fc11dc75ab5b63.svg";
export { ForwardRef as ReactComponent };